import { FormControlLabel, Radio, RadioGroup, Tooltip } from '@mui/material';

import { type SearchOption, searchOption, searchOptionSchema } from '../SearchOption.types';
import { content } from './SearchOptionSelector.content';

type SearchOptionSelectorProps = {
  readonly selectedSearchOption: SearchOption;
  readonly onChange: (newSearchOption: SearchOption) => void;
};

export const SearchOptionSelector = ({ selectedSearchOption, onChange }: SearchOptionSelectorProps) => (
  <RadioGroup
    row
    name="homepage-suche-radio-buttons"
    value={selectedSearchOption}
    onChange={(event) => onChange(searchOptionSchema.parse(event.target.value))}
  >
    <Tooltip title={content.THEMA_TOOLTIP} placement="bottom" disableInteractive arrow>
      <FormControlLabel value={searchOption.THEMA} control={<Radio />} label="Thema" sx={{ mr: 4 }} />
    </Tooltip>
    <Tooltip title={content.VERANSTALTUNG_TOOLTIP} placement="bottom" disableInteractive arrow>
      <FormControlLabel value={searchOption.VERANSTALTUNG} control={<Radio />} label="Veranstaltung" />
    </Tooltip>
  </RadioGroup>
);
